onInteractive(function () {
	// Navbar krijgt een achtergrond zodra de bezoeker voorbij de drempel scrolt.
	var header = document.querySelector('.nav-header');
	if (!header) {
		return;
	}

	var threshold = 80;
	function onScroll() {
		header.classList.toggle('is-scrolled', window.scrollY > threshold);
	}

	onScroll();
	window.addEventListener('scroll', onScroll, { passive: true });
});
